import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FormattedMessage as T, useIntl } from "react-intl";
import { Alert } from "@mui/material";
import ResponsiveIframe from "components/ResponsiveIframe";
import Loader from "components/Loader";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import { ResponseOfString } from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";

const useStyles = () => ({
  feedback: {
    width: "100%",
    margin: "20px 0 20px 0",
  },
});

type PreviewDialogProps = {
  open: boolean;
  handleConfirm: () => void;
  templateVersionId: string;
  organizationId: string;
};

const PreviewDialog = ({
  open,
  handleConfirm,
  templateVersionId,
  organizationId,
}: PreviewDialogProps) => {
  const styles = useStyles();
  const { formatMessage: t } = useIntl();
  const { templateService } = useGlobalContext();

  const fetchedPreview = useQuery<ResponseOfString>(
    ["getVersionPreview", templateVersionId, organizationId],
    () => templateService.getVersionPreview(templateVersionId, organizationId),
    {
      enabled: open,
    }
  );

  return (
    <Dialog open={open} disableEnforceFocus maxWidth="lg" fullWidth>
      <DialogTitle>
        <T id={"templatePreviewTitle"} />
      </DialogTitle>
      <DialogContent style={{ height: "100vh" }} dividers>
        {fetchedPreview.isError && (
          <Alert sx={styles.feedback} severity="error">
            {translateError(fetchedPreview.error, t)}
          </Alert>
        )}
        {fetchedPreview.isFetching ? (
          <Loader />
        ) : (
          <ResponsiveIframe
            srcDoc={fetchedPreview.data?.data!}
            title="templatePreview"
            fullHeight
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary" data-cy="cancelButton">
          <T id={"closeButton"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
